"use client";

import { Download } from "lucide-react";
import { NoxusFormLabel } from "@/components/Form/NoxusFormLabel";
import { getSpotFileUrl } from "@/utils/generic";
import { TextContainer } from "@/types";

export function TextPreviewInput({
  value,
  label,
}: {
  value: TextContainer;
  label?: string;
}) {
  const uri = value.file?.uri;

  return (
    <div className="flex w-full flex-col gap-2">
      {label && <NoxusFormLabel label={label} noMargin />}
      <div className="rounded-md border border-input bg-muted/30 p-3">
        <p className="max-h-[200px] overflow-y-auto whitespace-pre-wrap break-words text-sm">
          {value.text}
        </p>
        <div className="mt-2 flex items-center gap-3 border-t pt-2 text-xs text-muted-foreground">
          <span className="italic">Input truncated due to size</span>
          {uri && (
            <a
              href={getSpotFileUrl(uri)}
              download
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-primary underline hover:text-primary/80"
            >
              <Download size={12} />
              Download full input
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
